// /src/pages/Blog/style.js

import { Link } from "react-router-dom";
import styled from "styled-components";

export const BlogBanner = styled.div`
    position: relative;
    width: 100%;
    height: 30vh;
    background-image: url('/placa.png');
    background-size: cover;
    background-position: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    color: #ffffff;

    &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: rgba(0, 0, 0, 0.5);
    }

    h1, p {
        position: relative;
        z-index: 1;
    }

    h1 {
        font-size: 48px;
        font-weight: 700;
        margin-bottom: 10px;
    }

    p {
        font-size: 20px;
        max-width: 600px;
    }
`;

export const BlogGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    gap: 40px;
    padding: 60px 0;
`;

export const BlogCard = styled(Link)`
    text-decoration: none;
    color: inherit;
    background-color: #ede8e8ff;
    border: 3px solid #02391E;
    border-radius: 12px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    box-shadow: 0 4px 8px rgba(0,0,0,0.1);
    transition: transform 0.3s ease;

    &:hover {
        transform: translateY(-5px);
    }

    img {
        width: 100%;
        height: 200px;
        object-fit: cover;
    }
`;

export const CardContent = styled.div`
    padding: 20px;
    display: flex;
    flex-direction: column;
    flex-grow: 1;

    h3 {
        font-size: 20px;
        color: #02391E;
        margin-bottom: 10px;
        
    }

     p {
        font-size: 16px;
        line-height: 1.6;
        color: #575757;
        margin-bottom: 15px;

       
        overflow: hidden;               
        text-overflow: ellipsis;         
        display: -webkit-box;
        -webkit-line-clamp: 6;          
        -webkit-box-orient: vertical;
    }

       .card-footer {
        margin-top: auto; 
        font-size: 14px;
        color: #888;
        display: flex;          
        align-items: flex-end;  

       
        > span {
            margin-left: auto;   
            padding-left: 10px;
        }
    }
`;


export const FilterContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    gap: 20px;
    padding: 20px 0;
    border-bottom: 1px solid #ddd;

    select {
        padding: 8px 12px;
        border-radius: 6px;
        border: 1px solid #ccc;
        background-color: white;
    }
`;

export const FilterButton = styled.button`
    padding: 8px 16px;
    margin: 0 5px;
    border: 1px solid #02391E;
    border-radius: 20px;
    background-color: ${props => props.active ? '#02391E' : 'transparent'};
    color: ${props => props.active ? '#ffffff' : '#02391E'};
    cursor: pointer;
    transition: all 0.2s ease-in-out;

    &:hover {
        background-color: #02391E;
        color: #ffffff;
    }
`;

export const TagList = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin: 10px 0;
`;

export const TagBadge = styled.span`
    display: inline-block;
    padding: 4px 10px;
    background-color: #ccc;
    color: #333;
    border-radius: 12px;
    font-size: 12px;
    
    // Estilos adicionais quando usado como botão de filtro
    &[as="button"] {
        cursor: pointer;
        border: 1px solid transparent;
        background-color: ${props => props.active ? '#4CAF50' : '#ccc'};
        color: ${props => props.active ? 'white' : '#333'};
        
        &:hover {
            border-color: #4CAF50;
        }
    }
`;

export const ShowMoreButton = styled.button`
    background: none;
    border: none;
    color: #02391E;
    font-weight: bold;
    cursor: pointer;
    padding: 8px;
    margin-left: 10px;
    text-decoration: underline;

    &:hover {
        color: #4CAF50;
    }
`;

export const CategoryBadge = styled.div`
    display: inline-block;
    padding: 6px 12px;
    border-radius: 6px;
    font-size: 12px;
    font-weight: bold;
    margin-bottom: 12px;
    text-transform: uppercase;
    /* Estilos dinâmicos baseados nas props */
    background-color: ${props => props.bgColor || '#cccccc'};
    color: ${props => props.textColor || '#333333'};
`;